import React from "react";
import { Container, Col, Row, Div } from "../../components/grid";
import {
  Heading1,
  Paragraph,
  LinkStyled,
  Span,
  Heading2,
  List,
} from "../../components/typography";
import { ItemTraverser, Price } from "../../containers/commerce";
import SidemenuLayout from "../../layout/DefaultLayout/Layouts/SidemenuLayout";
import ProductView1 from "../../components/commerce/ProductViews/ProductView1";
import { ScreenSizeDetector } from "../../lib/helpers";
import { Image } from "../../components/Image";
import RowProductView from "../../components/grid/RowProductView";
import Sikrest10DageFoerText from "../../components/Variables/Sikrest10DageFoerText";

export default () => (
  <SidemenuLayout menuPicker="Anlaeg" activeSidemenu="Fadoelsanlaeg">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Fadølsanlæg</Heading1>
        </Col>
        <Col xs={12}>
          <Paragraph>
            Vi har alt i fadølsanlæg til din festlige lejlighed. Lej fadølsanlæg
            med enten med én eller flere haner og med eller uden tilhørende bar.
            Du kan også bestille det med stilladsbar eller stor
            udskænkningsvogn. Husk at bestille{" "}
            <LinkStyled to="/fadoel">fadøl</LinkStyled> i samme omgang som leje
            af fadølsanlæg.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="fadoelsanlaeg" display={ProductView1} />
      </RowProductView>
    </Container>
    <Container>
      <Row>
        <Col xs={12} lg={12} xl={4} padding="0">
          <ScreenSizeDetector
            margin={[[1199, "0px 0px 15px 0px"], "0px 7.5px 15px 0px"]}
          >
            <Div padding="15px" bgColor="white" infoBox textCenter>
              <Paragraph fontWeight="bold" fontSize="20px">
                <u>Altid</u> ledige fadølsanlæg
              </Paragraph>
              <Paragraph>
                Bestil mindst 1 uge før festen, så er der garanti for ledige
                fadølsanlæg til leje, ofte går det også med kortere varsel.{" "}
                <Span fontSize="12px">
                  <Sikrest10DageFoerText />
                </Span>
              </Paragraph>
            </Div>
          </ScreenSizeDetector>
        </Col>
        <Col xs={12} lg={12} xl={4} padding="0">
          <ScreenSizeDetector
            margin={[[1199, "0px 0px 15px 0px"], "0px 7.5px 15px 7.5px"]}
          >
            <Div padding="15px" bgColor="white" infoBox textCenter>
              <Paragraph fontWeight="bold" fontSize="20px">
                Levering eller hent selv
              </Paragraph>
              <Paragraph>
                Hent selv lejet fadølsanlæg alle hverdage mellem 7 - 16 eller få
                leveret, opsat og afhentet hele ugen, også i weekenden.
              </Paragraph>
            </Div>
          </ScreenSizeDetector>
        </Col>
        <Col xs={12} lg={12} xl={4} padding="0">
          <ScreenSizeDetector
            margin={[[1199, "0px 0px 15px 0px"], "0px 0px 15px 7.5px"]}
          >
            <Div padding="15px" bgColor="white" infoBox textCenter>
              <Paragraph fontWeight="bold" fontSize="20px">
                Betaling
              </Paragraph>
              <Paragraph>
                Lej fadølsanlæg online og brug dankort eller kreditkort ved
                bestilling. Vi hæver først pengene efter festen.
              </Paragraph>
            </Div>
          </ScreenSizeDetector>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Fadølsanlæg til enhver festlig lejlighed</Heading2>
          <Paragraph>
            Velkommen til Skafte! Vi er din pålidelige partner, når det kommer
            til at skabe uforglemmelige øjeblikke med vores fantastiske udvalg
            af fadølsanlæg. Uanset om du planlægger en lille intim fest eller et
            stort arrangement, har vi de perfekte løsninger til dig.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Leje af fadølsanlæg - Nem og bekvem løsning</Heading2>
          <Paragraph>
            Når du lejer et fadølsanlæg hos os, får du ikke bare et produkt, men
            en oplevelse. Vores leje af fadølsanlæg inkluderer alt, hvad du
            behøver for at kunne servere frisk og lækker fadøl til dine gæster.
            Vi sørger for, at du er køreklar fra start med køleanlæg og kulsyre
            - så du kan nyde festen uden bekymringer.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Typer af fadølsanlæg til leje</Heading2>
          <Paragraph>
            Vi tilbyder flere forskellige typer af fadølsanlæg, så du kan finde
            den løsning, der passer bedst til dit arrangement:
          </Paragraph>
          <List>
            <li>Basis: Enkelt hane</li>
            <li>Dobbelt: To haner</li>
            <li>Deluxe: Enkelt hane og bar</li>
            <li>High-end: To haner og bar</li>
            <li>Ultimate: Tre haner og bar</li>
          </List>
          <Paragraph>
            Uanset om du har en lille sammenkomst eller en stor fest, har vi et
            fadølsanlæg, der passer perfekt. Overvej, hvor mange gæster du
            forventer, så du kan vælge det rette antal haner.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Komplet pakke med leje af fadølsanlæg og bar</Heading2>
          <Paragraph>
            For dem, der ønsker den fulde oplevelse, tilbyder vi kombinerede
            løsninger med både fadølsanlæg og bar. Vælg mellem:
          </Paragraph>
          <List>
            <li>Deluxe: Bar med en hane</li>
            <li>High-end: Bar med to haner</li>
            <li>Ultimate: Bar med tre haner</li>
          </List>
          <Paragraph>
            Disse løsninger er perfekte til fester og arrangementer, hvor man
            ønsker en professionel og elegant opsætning. Baren giver en god
            arbejdshøjde og sikrer, at du kan skænke perfekt fadøl hele aftenen.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Udlejning af fadølsanlæg til større arrangementer</Heading2>
          <Paragraph>
            Hvis du står for at arrangere en stor fest eller et event med mange
            deltagere, har vi også løsninger til dig i form af{" "}
            <LinkStyled to="/fadoelsbar">barer til fadølsanlæg</LinkStyled>.
            Vores stilladsbar og udskænkningsvogn er ideelle til store events og
            festivaler, hvor du skal kunne servere fadøl hurtigt og effektivt.
            Når du vælger udlejning af fadølsanlæg hos os, får du professionel
            support og installation, så du kan fokusere på at nyde festen.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Billigt fadølsanlæg - Kvalitet til lav pris</Heading2>
          <Paragraph>
            Vi forstår, at budgettet kan spille en stor rolle. Derfor tilbyder
            vi et billigt fadølsanlæg til dem, der ønsker en prisvenlig løsning
            uden at gå på kompromis med kvaliteten. Vores billigste muligheder
            inkluderer enkelt- og dobbelthane-løsninger, hvor du monterer
            anlægget på dit eget bord. Selvom prisen er lav, går vi aldrig på
            kompromis med kvaliteten.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Sådan vælger du det rette fadølsanlæg</Heading2>
          <Paragraph>
            At vælge det rette fadølsanlæg kan virke som en stor beslutning, men
            vi er her for at hjælpe. Til mindre private fester kan et enkelt-
            eller dobbelthane-anlæg være tilstrækkeligt. Til større firmafester
            eller offentlige arrangementer kan du overveje en løsning med bar
            eller en større udskænkningsvogn. Vores eksperter står klar til at
            rådgive dig om det bedste valg for netop dit arrangement.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Let betjening og vedligeholdelse af vores fadølsanlæg
          </Heading2>
          <Paragraph>
            Alle kan betjene et fadølsanlæg, så du behøver ikke at hyre en
            professionel bartender til at skænke øl. Vores anlæg er nemme at
            sætte op og vedligeholde, og vi giver dig alle nødvendige
            instruktioner. Mange synes også, at det er en sjov ting at samles
            om, når man kan skænke sin egen øl direkte fra et fadølsanlæg.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Lej fadølsanlæg til både privat og erhverv</Heading2>
          <Paragraph>
            Hos Skafte tilbyder vi udlejning af fadølsanlæg til både private og
            erhvervskunder. Vi leverer til hele den østlige del af Sjælland samt
            Nordsjælland, og vi sikrer, at du får den bedste løsning til din
            fest eller event. Uanset om du har brug for et enkelt hane-anlæg til
            en mindre fest eller en stor udskænkningsvogn til en festival, har
            vi det, du skal bruge.
          </Paragraph>
          <Paragraph>
            Vi har mange års erfaring med at levere til private fester, når der
            skal fejres bryllup, fødselsdag og andre store livsbegivenheder.
            Skafte leverer desuden ofte til firmaarrangementer, såsom DHL,
            firmafester og events.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Fordelene ved udlejning af fadølsanlæg</Heading2>
          <Paragraph>
            Når du vælger udlejning af fadølsanlæg hos Skafte, får du ikke kun
            adgang til et bredt udvalg af kvalitetsanlæg, men også en række
            fordele, der gør din oplevelse bedre. Vi tilbyder fleksible
            lejeaftaler, professionel installation og support samt muligheden
            for at returnere ubrugte fustager. Dette gør os til den ideelle
            partner, når du skal holde fest eller arrangere en begivenhed.
          </Paragraph>
          <Paragraph>
            Når du lejer et fadølsanlæg, slipper du også for besværet med at
            samle og returnere flasker og dåser efter festen, og dine gæster får
            en bedre oplevelse med frisk skænket fadøl. Det er også mere
            miljøvenligt og økonomisk fordelagtigt at bruge fadøl frem for dåser
            og flasker.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Få mere ud af din fest med et fadølsanlæg</Heading2>
          <Paragraph>
            Et fadølsanlæg kan virkelig løfte stemningen til din fest. Der er
            noget særligt ved at kunne tilbyde dine gæster frisk skænket fadøl.
            Det er ikke kun smagen, der er bedre; hele oplevelsen bliver også
            mere social og sjov, når folk samles omkring baren for at få skænket
            en kold øl.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Hvad er inkluderet i lejen af et fadølsanlæg?</Heading2>
          <Paragraph>
            Når du lejer et fadølsanlæg hos Skafte, inkluderer lejen som minimum
            en hane, køleanlæg og kulsyre. Ved større anlæg medfølger flere
            haner og tilhørende udstyr.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Kan jeg returnere ubrudte fustager?</Heading2>
          <Paragraph>
            Ubrugte fustager kan returneres til fuld pris minus{" "}
            <Price varenr="641" /> kr. pr. stk. Dette gør det nemt at bestille
            lidt ekstra uden at bekymre dig om spild.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Kan jeg selv afhente fadølsanlæg og fustager?</Heading2>
          <Paragraph>
            Ja, du kan selv hente fadølsanlæg og fustager, men vi tilbyder også
            levering og afhentning for din bekvemmelighed.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Godt at vide om fadølsanlæg</Heading2>
          <Paragraph>
            Køleboksen måler: (BxLxH) 54x44x26,5 cm og vejer 44 kg. Kan kun stå
            på én flade (som vist på billedet). Tappehanen kan monteres på en
            bordkant, vindueskarm eller lignende. Prisen for leje omfatter:
            Køleboks og tappehane.
          </Paragraph>
          <Paragraph>
            Lejeprisen på kr. <Price varenr="3607" /> betinger køb af fustager.
            Lejeprisen omfatter 5 dages leje.
          </Paragraph>
          <Paragraph>
            Lejer du mere end et anlæg af gangen er prisen for de følgende anlæg
            også kr. <Price varenr="3607" />
            Der leveres sædvanligvis 1 stk. 6 kg. kulsyre med anlægget.
          </Paragraph>
          <Paragraph>
            Kulsyreflasken er 71,5 cm høj og har diameteren 16 cm Vi henter og
            bringer gerne varerne, men det er også muligt selv at hente
            fadølsanlæg og fustager.
          </Paragraph>
          <Div textCenter>
            <Image
              name="packs.basis-5.png"
              alt="Fadøls køleanlæg med tappetårn og kulsyreflaske"
              title="Fadøls køleanlæg med tappetårn og kulsyreflaske"
              maxHeight="275px"
              imageHeight="275px"
            />
          </Div>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>Har du spørgsmål til leje af fadølsanlæg?</Heading2>
          <Paragraph>
            Hos Skafte er vi stolte af vores engagement i at levere produkter og
            service af højeste kvalitet. Vi ved, at vores kunder forventer det
            bedste, og derfor sørger vi for, at alle vores fadølsanlæg er i
            topstand og klar til brug. Vores team af eksperter står altid klar
            til at hjælpe dig med rådgivning og support, så du får den bedste
            oplevelse muligt.
          </Paragraph>
          <Paragraph>
            Har du spørgsmål til vores udlejning af fadølsanlæg, eller har du
            brug for hjælp til at vælge det rette anlæg til din fest? Kontakt os
            på telefon 4327 0000 eller mail{" "}
            <LinkStyled to="mailto:peter@skafte.dk">peter@skafte.dk</LinkStyled>
            . Vores eksperter sidder klar til at hjælpe dig med at gøre din
            næste fest eller arrangement til en succes med frisk og velsmagende
            fadøl.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
